import React, { useContext } from 'react';
import moment from 'moment';
import { Card } from 'react-bootstrap';
import DealContext from '../DealContext';
import SimpleQuoteBadge from '../SimpleQuoteBadge';
import RenderMd from '../../../util/markdown';

const NotesCard = () => {
  const { handleNewNote, notes, presentQuote, quoteList } = useContext(DealContext);

  return (
    <Card>
      <div className="card-toolbar">
        <div className="card-toolbar-button" onClick={handleNewNote}>
          <i className="fas fa-plus fa-fw" />
        </div>
      </div>
      <Card.Body>
        <Card.Title>
          {notes.length} {`Note${notes.length !== 1 ? 's' : ''}`}
        </Card.Title>
        {notes.length === 0 ? (
          <Card.Text>
            <i>Notes created on any quotes in this deal will be displayed here.</i>
          </Card.Text>
        ) : (
          notes.map(note => {
            return (
              <Card key={note.id} style={{ backgroundColor: 'var(--yellow-0)' }}>
                <Card.Body>
                  <Card.Title>
                    {note.title}
                    <SimpleQuoteBadge
                      className="float-right"
                      quote={quoteList.find(q => Number(note.itemId) === q.id)}
                      onClick={() => presentQuote(note.itemId)}
                    />
                  </Card.Title>
                  <RenderMd className="custom-html-style" md={note.body} />
                </Card.Body>
                <Card.Footer>
                  <div className="footer-date-user">
                    <small>{moment(new Date(note.createdAt)).fromNow()}</small>
                    <small>{note.authorName}</small>
                  </div>
                </Card.Footer>
              </Card>
            );
          })
        )}
      </Card.Body>
    </Card>
  );
};

export default NotesCard;
